export enum ContactFieldVisibility {
  Both = 'both',
  EmailOnly = 'email-only',
  PhoneOnly = 'phone-only',
}
